/* Casa Manavay · botón flotante "Volver a la compra" (15 oct 2026, pedido de Nicolás tras crítica de clientes).
   Aparece en todas las páginas de producto cuando el cliente ya bajó más allá del recuadro de compra,
   y se oculta cuando vuelve a ver el recuadro o cuando está viendo el cierre o las tarjetas de packs.
   Al tocarlo, sube al recuadro de compra (Releasit) donde están los packs y "Pedir ahora". */
(function(){
  if(window.cmVolverOk) return; window.cmVolverOk = true;
  var intentos = 0, caja = null, btn = null, viendoCierre = false;
  function buscarCaja(){ return document.querySelector('.cm-buy') || document.querySelector('.rsi_embedded_quantity_wrapper') || document.querySelector('.product-form__buttons') || document.querySelector('product-form'); }
  function estilos(){
    var st = document.createElement('style'); st.id = 'cm-volver-css';
    st.textContent = '#cm-volver{position:fixed;left:50%;bottom:14px;z-index:60;display:flex;align-items:center;gap:12px;width:calc(100% - 28px);max-width:440px;padding:12px 18px 12px 12px;border:0;border-radius:14px;background:#C8F135;color:#0D0D0D;cursor:pointer;text-align:left;box-shadow:0 12px 34px rgba(0,0,0,.55),0 0 0 1px rgba(0,0,0,.2);transform:translate(-50%,140%);opacity:0;pointer-events:none;transition:transform .35s cubic-bezier(.2,.7,.2,1),opacity .25s;font-family:Inter,system-ui,sans-serif}'
      + '#cm-volver.is-on{transform:translate(-50%,0);opacity:1;pointer-events:auto}'
      + '#cm-volver i{flex:0 0 38px;width:38px;height:38px;border-radius:10px;background:#0D0D0D;color:#C8F135;display:flex;align-items:center;justify-content:center;font-style:normal}'
      + '#cm-volver i svg{width:20px;height:20px}'
      + '#cm-volver b{display:block;font:900 19px/1.05 "Barlow Condensed","Arial Narrow",sans-serif;letter-spacing:.06em;text-transform:uppercase;color:#0D0D0D}'
      + '#cm-volver small{display:block;margin-top:3px;font-size:12px;line-height:1.3;font-weight:600;color:rgba(13,13,13,.75)}'
      + '@media (min-width:750px){#cm-volver{bottom:22px}}'
      + '@media (prefers-reduced-motion:reduce){#cm-volver{transition:none}}';
    document.head.appendChild(st);
  }
  function actualizar(){
    if(!caja || !btn) return;
    var r = caja.getBoundingClientRect();
    btn.classList.toggle('is-on', r.bottom < 0 && !viendoCierre);
  }
  function subir(){
    var y = caja.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }
  function armar(){
    caja = buscarCaja();
    if(!caja){ if(intentos++ < 60){ setTimeout(armar, 250); } return; }
    if(!caja.classList.contains('cm-buy') && document.querySelector('.rsi_embedded_quantity_wrapper') === null && intentos < 20){ intentos++; setTimeout(armar, 250); return; }
    if(document.getElementById('cm-volver')) return;
    estilos();
    btn = document.createElement('button');
    btn.type = 'button'; btn.id = 'cm-volver'; btn.setAttribute('aria-label', 'Volver a la compra');
    btn.innerHTML = '<i aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg></i><span><b>Volver a la compra</b><small>Elige tu pack y pide</small></span>';
    btn.addEventListener('click', subir);
    document.body.appendChild(btn);
    var cierres = document.querySelectorAll('.lp-ci, .cpk');
    if(cierres.length && 'IntersectionObserver' in window){
      var vis = 0;
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ vis += e.isIntersecting ? 1 : -1; });
        if(vis < 0) vis = 0;
        viendoCierre = vis > 0; actualizar();
      }, { threshold: 0.25 });
      cierres.forEach(function(c){ io.observe(c); });
    }
    window.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', armar); } else { armar(); }
})();